import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-video-preview',
  templateUrl: './video-preview.component.html',
  styleUrls: ['./video-preview.component.css']
})
export class VideoPreviewComponent implements OnInit {

  @Input() data: any = null;
  @Output() onValidation = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() { }

  durationToString(duration: string): string {
    const seconds = this.convertISO8601ToSeconds(duration);

    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 3600 % 60);

    const hDisplay = h > 0 ? h + " hr " : "";
    const mDisplay = m > 0 ? m + " min " : "";
    const sDisplay = s > 0 ? s : "";
    return hDisplay + mDisplay + sDisplay;
  }

  isDurationValid(duration: string): boolean {
    const seconds = this.convertISO8601ToSeconds(duration);
    const isValid = seconds > 180 ? false : true;
    this.onValidation.emit(isValid);
    return isValid;
  }

  private convertISO8601ToSeconds(input: string): number {
    const reptms = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
    let hours = 0, minutes = 0, seconds = 0, totalseconds;
    if (reptms.test(input)) {
      const matches = reptms.exec(input);
      if (matches[1]) hours = Number(matches[1]);
      if (matches[2]) minutes = Number(matches[2]);
      if (matches[3]) seconds = Number(matches[3]);
      totalseconds = hours * 3600  + minutes * 60 + seconds;
    }
    return (totalseconds);
  }

}
